import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiMutationHook } from '../../../common/queryClient/createApiMutationHook';
import { InputDataEditSessionUrl } from '../InputDataEditSessionUrl';

const deleteInputDataDrafts = async ({
  sessionId,
  rowIds,
}: {
  sessionId: string;
  rowIds: number[];
}) =>
  apiClient
    .patch(expand(InputDataEditSessionUrl.rows, { sessionId }), {
      drafts: rowIds.map((rowId) => ({ rowId, op: 'DELETE', payload: null })),
    })
    .then((response) => response.data);

export const useDeleteInputDataDraftsMutation = createApiMutationHook(
  ['input-data-draft-delete'],
  deleteInputDataDrafts,
);
